import React, { Component } from 'react';
import Image from 'react-bootstrap/Image';
import { Dropdown, Modal } from "react-bootstrap";
import { FaBell, FaQuestionCircle } from "react-icons/fa";
import { Link } from 'react-router-dom';
import Config from '../lib/Config';

export default class Top extends Component {

    constructor(props) {
        super(props)
        this.state = {
            profilePictureData: localStorage.getItem("profilePictureData") ? localStorage.getItem("profilePictureData") : "",
            showVersionModal: false,
        }
    }

    componentDidUpdate(prevProps) {
        if(this.props.profilePic && this.props.profilePic !== prevProps.profilePic) {
            this.setState({ profilePictureData: this.props.profilePic });
        } 
    }

    componentDidMount() {
        const wasSessionEnding = localStorage.getItem('session_ending');
        const wasRefreshing = sessionStorage.getItem('reloading');

        if (wasSessionEnding) {
            localStorage.removeItem('session_ending');
            sessionStorage.removeItem('reloading');
            if (!wasRefreshing) {
                // Tab was closed (not refreshed) — perform deferred logout
                fetch(Config.getUrl() + '/login/logout', { method: 'POST' }).catch(() => {});
                localStorage.clear();
                window.location.hash = '/sign-in';
                return;
            }
        }

        window.addEventListener('beforeunload', this.handleBeforeUnload);
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    handleBeforeUnload = () => {
        if (!localStorage.getItem('jwttoken')) return;
        // Mark pending logout — sessionStorage survives refresh but not tab close.
        // The actual logout fires on next mount if reloading flag is absent (close scenario).
        sessionStorage.setItem('reloading', 'true');
        localStorage.setItem('session_ending', 'true');
    }

    handleLogout = () => {
        fetch(Config.getUrl() + '/login/logout', { method: 'POST' }).catch(() => {});
        sessionStorage.setItem('logoutMessage', 'You have been logged out. Please login again.');
        localStorage.clear();
    }

    render() {
        
        return (
            <>
            <nav className="navbar navbar-expand navbar-light topbar mb-0 static-top">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item no-arrow mx-1">
                        <span
                            className="nav-link nav-link-lg"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.setState({ showVersionModal: true })}
                            title="About"
                        >
                            <FaQuestionCircle style={{ fontSize: "1.5rem" }} />
                        </span>
                    </li>
                    <li className="nav-item dropdown no-arrow mx-1">
                        {['left'].map((direction) => (
                            <Dropdown key={direction} id={`dropdown-button-drop-${direction}`} drop={direction} >
                                <Dropdown.Toggle className="nav-link nav-link-lg" id="alerts">
                                    <FaBell className="side-menu__icon" style={{ fontSize: "2rem !important" }} />
                                    <span className="pulse bg-warning"></span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu menuAlign="left" className="dropdown-list dropdown-menu-left shadow">
                                    <h6 className="dropdown-header">Alerts Center</h6>
                                    {/* <Dropdown.Item href="/Doctor" className="align-items-center">
                                        <div className="small text-gray-500">July 22, 2019</div>
                                        <span className="font-weight-bold">Dell India submitted response for the event "RFP for Laptops"</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item href="#" className="align-items-center" style={{ whiteSpace: "break-spaces" }}>
                                        <div className="small text-gray-500">July 22, 2019</div>
                                        <span className="font-weight-bold">Dell India submitted response for the event "RFP for Laptops"</span>
                                    </Dropdown.Item>
                                    <Dropdown.Item href="#" className="align-items-center">
                                        <div className="small text-gray-500">July 22, 2019</div>
                                        <span className="font-weight-bold">Dell India submitted response for the event "RFP for Laptops"</span>
                                    </Dropdown.Item> */}
                                </Dropdown.Menu>
                            </Dropdown>
                        ))}
                    </li>
                    <li className="nav-item dropdown no-arrow">
                        <Dropdown>
                            <Dropdown.Toggle className="nav-link nav-link-lg" id="alertsDropdown">
                                <span>
                                    {(() => {
                                        if (this.state.profilePictureData !== "undefined" && this.state.profilePictureData !== null && this.state.profilePictureData !== '') {
                                            return (
                                                <Image src={this.state.profilePictureData} className="rounded-circle w-32 mr-2" />
                                            )
                                        }else{
                                            return (
                                                <Image src={`${process.env.PUBLIC_URL}/img/profile-male.png`} className="rounded-circle w-32 mr-2" />
                                            )
                                        }
                                    })()}
                                </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu dropdown-menu-right shadow p-3">
                                <Link to="/Doctor" className="d-flex align-items-center dropdown-item">My Profile</Link>
                                {/* <Link to="#" className="d-flex align-items-center dropdown-item">Settings</Link>
                                <Link to="#" className="d-flex align-items-center dropdown-item">Reset Password</Link> */}
                                <Dropdown.Divider />
                                <Link to="/sign-in" className="d-flex align-items-center dropdown-item" onClick={this.handleLogout}>Logout</Link>
                            </Dropdown.Menu>
                        </Dropdown>
                    </li>
                </ul>
            </nav>

            <Modal show={this.state.showVersionModal} onHide={() => this.setState({ showVersionModal: false })} centered size="sm">
                <Modal.Header closeButton>
                    <Modal.Title>About</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center py-4">
                    <p className="mb-1"><strong>ARISTO</strong></p>
                    <p className="text-muted mb-0">{process.env.REACT_APP_VERSION || 'N/A'}</p>
                </Modal.Body>
            </Modal>
            </>
        )
    }
}